import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";

import { abfSerializeQueryArgs, marketsPublicBaseQuery } from "./util";
import { PaginatedTimeLockResponse, TimeLockFilter } from "../types";
import { parsePaginatedTimeLockResponseFromApi } from "../types/parsers";
import { ROUTE_GET_TIMELOCKS } from "../constants";
import { PaginatedTimeLockResponseApi } from "../types/api";

const TIME_LOCK_TAG = "TimeLock";

export const timelocksApi = createApi({
    reducerPath: "timelocksApi",
    baseQuery: marketsPublicBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,
    tagTypes: [TIME_LOCK_TAG],
    endpoints: (builder) => ({
        timelockList: builder.query<PaginatedTimeLockResponse, TimeLockFilter>({
            providesTags: [TIME_LOCK_TAG],
            query(params) {
                return {
                    url: ROUTE_GET_TIMELOCKS,
                    method: "POST",
                    body: params
                };
            },
            transformResponse: (response: PaginatedTimeLockResponseApi): PaginatedTimeLockResponse => {
                return parsePaginatedTimeLockResponseFromApi(response);
            }
        })
    })
});

export const { useTimelockListQuery } = timelocksApi;

export function useTimelocksApi() {
    const dispatch = useDispatch();

    return {
        resetTimelocksApi: () => dispatch(timelocksApi.util.invalidateTags([TIME_LOCK_TAG]))
    };
}
